import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../../components/Layout";
import UsersCreateContent from "../../../components/Pages/Users/Create";

const { displayName } = config;

export default function UsersCreate(): React.ReactNode | null {
  useEffect(() => {
    document.title = `${displayName}: Users Create`;
  }, []);

  return (
    <Layout>
      <UsersCreateContent />
    </Layout>
  );
}
